import path from 'path'
import Vue from "vue"

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */
const getters = {
    get: (state, getters, rootState) => rootState.appStore.options
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */
const mutations = {
    setOptions(state, options) {
        Vue.set(this.state.appStore, 'options', options)
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    set({ commit }, options) {
        commit("setOptions", options)
    }
}

export default {
    namespaced: true,
    namespace: "options",
    modules: getModules('options'),
    getters,
    mutations,
    actions
}
